import React, { useEffect, useState } from 'react';
import { PlanningState } from '../model/Planning';
import { Transaction, TransactionState } from '../model/Transaction';
import { showMessage } from '../services/popup';
import { getTransactions } from '../services/service';

const SIZE = 50;

const PayPage: React.FC = () => {
  const [page, setPage] = useState(0);
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [pattern, setPattern] = useState('');

  const loadTransactions = async (p: number, ptn?: string) => {
    try {
      setTransactions(await getTransactions(p * SIZE, SIZE + 1, ptn ?? pattern));
    } catch (e) {
      showMessage('Une erreur est survenue: ' + JSON.stringify(e));
    }
  };

  const stateToString = (state: PlanningState): string => {
    switch (state) {
      case PlanningState.Done: return 'Terminee';
      case PlanningState.Null: return '';
      case PlanningState.Reserved: return 'Reservee';
      case PlanningState.Reserving: return 'En cours de reservation';
      case PlanningState.Empty: return '';
      case PlanningState.Validated: return 'Validee';
      default: return '';
    }
  };

  const hasNext = transactions.length > SIZE;
  const hasPrevious = page > 0;

  const movePage = (next: number) => {
    if (next >= 0) {
      setPage(next);
      loadTransactions(next);
    }
  };

  const search = () => {
    setPage(0);
    loadTransactions(0, pattern);
  };

  useEffect(() => {
    loadTransactions(0, '');
  }, []);

  return (
    <div className="page-stack">
      <section className="panel">
        <div className="toolbar-row">
          <input value={pattern} onChange={(e) => setPattern(e.target.value)} placeholder="Reference paiement" />
          <button className="primary-btn" onClick={search}>Rechercher</button>
          <div className="pager-inline">
            <button className="ghost-btn" disabled={!hasPrevious} onClick={() => movePage(page - 1)}>Precedent</button>
            <span>Page {page + 1}</span>
            <button className="ghost-btn" disabled={!hasNext} onClick={() => movePage(page + 1)}>Suivant</button>
          </div>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Reference</th>
                <th>Client</th>
                <th>Prix</th>
                <th>Date achat</th>
                <th>Etat</th>
                <th>Reduction</th>
                <th>Packs</th>
                <th>Seances</th>
              </tr>
            </thead>
            <tbody>
              {transactions.slice(0, SIZE).map((l, i) => (
                <tr key={i}>
                  <td className="mono">{l.referenceId}</td>
                  <td>{l.clientName}</td>
                  <td className="mono">{l.price.default} {'->'} {l.price.final}</td>
                  <td>{new Date(l.date).toLocaleDateString()} {new Date(l.date).toLocaleTimeString()}</td>
                  <td>{TransactionState[l.state].toString()}</td>
                  <td className="mono">{l.reductionCode}</td>
                  <td>{l.packBougth}</td>
                  <td>
                    <div className="session-stack">
                      {l.sessions.map((s, j) => (
                        <article className="session-card" key={j}>
                          <strong>{s.coachName}</strong>
                          <div>{new Date(s.date).toLocaleDateString()} {new Date(s.date).toLocaleTimeString()}</div>
                          <div>{stateToString(s.state)}</div>
                          <div>{s.sessionPrice} EUR {s.byPack ? '(Pack)' : ''}</div>
                          <div>{s.refunded ? `Rembourse le ${new Date(s.refundDate ?? new Date()).toLocaleDateString()}` : ''}</div>
                          {s.deleted && <span className="pill bad">Annulee</span>}
                        </article>
                      ))}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default PayPage;
